export default __webpack_public_path__ + "static/media/previousquestionsjee.c46b4801.jpeg";